<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table {
  height: 260px;
  margin: 0 auto;
  padding: 10px 10px;
  color: #fff;
  text-align: center;
  overflow: hidden;

  .main {
    width: 100%;
    height: 100%;

    .list-item{
      height: 50px;
      line-height: 50px;
      display: flex;
      .item:nth-child(1){
        width: 20%;
      }
      .item:nth-child(2){
        width: 60%;
      }
      .item:nth-child(3){
        width: 20%;
      }
      .red {
        width: 84px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: rgba(208, 92, 119, 1);
        border-radius: 8px;
        margin-top: 10px;
      }
    }
  }
}
</style>

<template>
  <boxWrap :name="name" style="margin-top:20px">
    <div class="table">
      <div class="main">
        <swiper :options="swiperOption" class="swiper-wrap"  ref="mySwiper" v-if="tableData.length!=0">
          <swiper-slide v-for="(item,index) in tableData" :key="index" class="list-item"> 
            <div class="item">{{item.area}}</div>
            <div class="item">{{item.name}}</div>
            <div class="item red">红榜</div>
          </swiper-slide>
        </swiper>
        
      </div>
    </div>
  </boxWrap>
</template>

<script>
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    const that = this;
    return {
      name: '企业红黑榜',
      tableData: [
        { area: '田阳县', name: '广西百色盛泰和农业有限公司' },
        { area: '田阳县', name: '广西田阳新靖田农产品贸易有限公司 ' },
        { area: '田阳县', name: '广西田阳穗丰园农产品贸易有限公司' },
        { area: '田阳县', name: '广西田阳天穗农产品贸易有限公司' },
        { area: '田阳县', name: '田阳县蔬心特色农产品经营部' },
        { area: '田阳县', name: '广西田阳骄阳农产品贸易有限公司' },
        { area: '田阳县', name: '广西百色翠丰特色农产品有限责任公司' }
      ],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  mounted() {

  }
}

</script>



// WEBPACK FOOTER //
// index.vue?4eb62bfe